import styled from 'styled-components'

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 30px;
  padding-bottom: 50px;
  position: relative;
`

export const Title = styled.span`
  color: #1e7be1;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 24px;
  font-weight: bold;
  display: block;
  margin-bottom: 40px;
`

export const Sutitle = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  letter-spacing: 0px;
  color: #1d1d1d;
  display: block;
  font-weight: bold;
`

export const Label = styled.label`
  color: #1d1d1d;
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  font-weight: bold;
`
